import { DxPopupModule, DxButtonModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationPopUpComponent } from './confirmation-pop-up.component';



@NgModule({
	declarations: [ConfirmationPopUpComponent],
	exports: [ConfirmationPopUpComponent],
  imports: [
		CommonModule,
		DxPopupModule,
		DxButtonModule,
  ]
})
export class ConfirmationPopUpModule { }
